import Modal from './Modal.vue'; // Path to your component

export default {
	install(Vue) {
		const ModalConstructor = Vue.extend(Modal);
		
		// Pass custom runtime default config options as instance props
		const modalInstance = new ModalConstructor().$mount();
		
		document.body.appendChild(modalInstance.$el);

		// Map the global property hook to the prototype
		Vue.prototype.$modal = {
			confirm(message, options) {
				return modalInstance.open('confirm', message, options);
			},
			alert(message, options) {
				return modalInstance.open('alert', message, options);
			}
		};
	}
};
